import React from "react";
import {
	Box,
	Card,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import GroupsTwoToneIcon from "@mui/icons-material/GroupsTwoTone";
import type { ISessionRequest } from "src/Types/module/b2bSession/b2bSessionRequest.types";
import SessionRequestTableRow from "../../B2BSession/SessionRequest/SessionRequestTableRow";

interface Props {
	sessionRequests?: ISessionRequest[];
}

const B2BSingleSessionRequestsTable: React.FC<Props> = ({
	sessionRequests = [],
}) => {
	if (!sessionRequests || sessionRequests.length === 0) {
		return (
			<Card
				elevation={0}
				sx={{
					p: 3,
					my: 1,
					textAlign: "center",
					bgcolor: "background.paper",
					border: "1px dashed",
					borderColor: "divider",
					borderRadius: 1.5,
				}}
			>
				<Box
					display="flex"
					flexDirection="column"
					alignItems="center"
					justifyContent="center"
					gap={0.5}
				>
					<GroupsTwoToneIcon
						sx={{ fontSize: 38, color: "text.secondary", opacity: 0.6 }}
					/>
					<Typography variant="h5" fontWeight={600} color="text.secondary">
						No Session Requests Found
					</Typography>
					<Typography variant="caption" color="text.disabled">
						This B2B member does not have any session requests yet.
					</Typography>
				</Box>
			</Card>
		);
	}

	return (
		<Box sx={{ mt: 1 }}>
			<TableContainer
				component={Card}
				elevation={0}
				sx={{
					border: "1px solid",
					borderColor: "divider",
					borderRadius: 1.5,
					overflow: "hidden",
				}}
			>
				<Table size="small">
					<TableHead sx={{ bgcolor: "grey.50" }}>
						<TableRow>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>SL.</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>From B2B (Requester)</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>To B2B (Invited)</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>Session Slot</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>Note / Reason</TableCell>
							<TableCell sx={{ fontWeight: 700, py: 1 }}>Status</TableCell>
							<TableCell align="right" sx={{ fontWeight: 700, py: 1 }}>
								Action
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{sessionRequests.map((request, index) => (
							<SessionRequestTableRow
								key={request.id || index}
								request={request}
								serial={index + 1}
							/>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};

export default B2BSingleSessionRequestsTable;
